import { useEffect, useState } from "react";
import { Plane, TrainFront, Users, Luggage, Wallet, Paperclip, FolderOpen } from "lucide-react";
import api from "../../lib/api";
import { CountdownRing } from "./TripsSection";

/* One-glance trip snapshot: countdown, flights/trains, travelers, packing %,
   expenses total, receipts and files. Refreshes when refreshKey changes. */

const money = (n, ccy) => `${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2 })} ${ccy}`;

const Tile = ({ icon: Icon, label, value, sub, testid }) => (
  <div className="border border-zinc-200 bg-white px-3 py-2.5 flex items-center gap-2.5 min-w-0" data-testid={testid}>
    <Icon className="w-4 h-4 text-[#0e7490] shrink-0" />
    <div className="min-w-0">
      <div className="font-mono font-700 text-sm text-zinc-900 truncate">{value}</div>
      <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground truncate">{label}{sub ? ` · ${sub}` : ""}</div>
    </div>
  </div>
);

export default function TripOverview({ tripId, refreshKey }) {
  const [o, setO] = useState(null);
  useEffect(() => {
    api.get(`/trips/${tripId}/overview`).then((r) => setO(r.data)).catch(() => {});
  }, [tripId, refreshKey]);
  if (!o) return null;

  return (
    <section className="mb-8" data-testid="trip-overview">
      <div className="flex items-center gap-4 border border-zinc-300 bg-zinc-50 p-4 flex-wrap">
        <CountdownRing startDate={o.start_date} endDate={o.end_date} size={58} />
        <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
          <Tile icon={Plane} label="Flights" value={o.flights} sub={o.trains ? `${o.trains} trains` : null} testid="overview-flights" />
          <Tile icon={Users} label="Travelers" value={o.travelers} testid="overview-travelers" />
          <Tile icon={Luggage} label="Packing" testid="overview-packing"
            value={o.packing.total ? `${o.packing.pct}%` : "—"}
            sub={o.packing.total ? `${o.packing.packed}/${o.packing.total} packed` : "no list yet"} />
          <Tile icon={Wallet} label="Expenses" testid="overview-expenses"
            value={o.expenses.count ? money(o.expenses.total, o.expenses.home_currency) : "—"}
            sub={o.expenses.count ? `${o.expenses.count} entries` : "none yet"} />
          <Tile icon={Paperclip} label="Receipts" value={o.receipts} testid="overview-receipts" />
          <Tile icon={FolderOpen} label="Files" value={o.files} testid="overview-files" />
        </div>
      </div>
    </section>
  );
}
